var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAiLogEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 110,
    viewBox: "0 0 200 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.584 23.4648C179.404 23.4648 182.5 26.5572 182.5 30.3718C182.5 34.1864 179.404 37.2788 175.584 37.2788H136.063C139.883 37.2788 142.979 40.3712 142.979 44.1858C142.979 48.0004 139.883 51.0928 136.063 51.0928H157.799C161.619 51.0928 164.716 54.1851 164.716 57.9997C164.716 61.8143 161.619 64.9067 157.799 64.9067H147.747C142.931 64.9067 139.027 67.9991 139.027 71.8137C139.027 74.3568 141.003 76.6591 144.955 78.7207C148.775 78.7207 151.871 81.813 151.871 85.6276C151.871 89.4423 148.775 92.5346 144.955 92.5346H62.9491C59.1294 92.5346 56.0329 89.4423 56.0329 85.6276C56.0329 81.813 59.1294 78.7207 62.9491 78.7207H24.4162C20.5965 78.7207 17.5 75.6283 17.5 71.8137C17.5 67.9991 20.5965 64.9067 24.4162 64.9067H63.9371C67.7568 64.9067 70.8533 61.8143 70.8533 57.9997C70.8533 54.1851 67.7568 51.0928 63.9371 51.0928H39.2365C35.4168 51.0928 32.3204 48.0004 32.3204 44.1858C32.3204 40.3712 35.4168 37.2788 39.2365 37.2788H78.7575C74.9378 37.2788 71.8413 34.1864 71.8413 30.3718C71.8413 26.5572 74.9378 23.4648 78.7575 23.4648H175.584ZM175.584 51.0928C179.404 51.0928 182.5 54.1851 182.5 57.9997C182.5 61.8143 179.404 64.9067 175.584 64.9067C171.764 64.9067 168.668 61.8143 168.668 57.9997C168.668 54.1851 171.764 51.0928 175.584 51.0928Z",
    fill: "#D6DCE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.7 10.6C154.246 10.6 155.5 9.3464 155.5 7.8C155.5 6.2536 154.246 5 152.7 5C151.154 5 149.9 6.2536 149.9 7.8C149.9 9.3464 151.154 10.6 152.7 10.6Z",
    fill: "#E7EBF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2 93.4C47.0719 93.4 49.4 91.0719 49.4 88.2C49.4 85.3281 47.0719 83 44.2 83C41.3281 83 39 85.3281 39 88.2C39 91.0719 41.3281 93.4 44.2 93.4Z",
    fill: "#E7EBF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159 85.75C162.333 85.75 164.25 87.625 164.25 91H165.75C165.75 87.625 167.625 85.75 171 85.75V84.25C167.625 84.25 165.75 82.375 165.75 79H164.25C164.25 82.375 162.375 84.25 159 84.25V85.75Z",
    fill: "#989FB0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150 63.7561C150 57.4438 135.639 52.3223 117.917 52.3223C100.201 52.3223 85.8395 57.444 85.8395 63.7561V74.2651C85.8395 80.5774 100.201 85.699 117.917 85.699C135.639 85.699 150 80.5773 150 74.2651V63.7561Z",
    fill: "#989FB0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.917 52.3223C100.2 52.3223 85.839 57.444 85.839 63.7561C85.839 70.0732 100.2 75.19 117.917 75.19C135.638 75.19 150 70.0734 150 63.7561C150 57.4438 135.638 52.3223 117.917 52.3223Z",
    fill: "#E7EBF6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.917 57.666C103.822 57.666 92.3976 60.3966 92.3976 63.7569C92.3976 67.1222 103.822 69.8477 117.917 69.8477C132.013 69.8477 143.442 67.122 143.442 63.7569C143.442 60.3966 132.013 57.666 117.917 57.666Z",
    fill: "#A3ACBD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_48240_43587)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.317 28.2008C115.161 22.7342 100.163 25.4794 84.8157 34.3402C69.4726 43.1985 59.5963 54.8146 62.7524 60.2811L68.0069 69.3821C71.1631 74.8488 86.161 72.1036 101.504 63.2452C116.851 54.3845 126.728 42.7684 123.572 37.3019L118.317 28.2008Z",
    fill: "#989FB0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.8152 34.3421C69.4721 43.2004 59.5958 54.8165 62.7519 60.2831C65.9105 65.7538 80.906 63.0045 96.249 54.1462C111.596 45.2854 121.475 33.6737 118.317 28.2028C115.161 22.7361 100.162 25.4814 84.8152 34.3421Z",
    fill: "#E7EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.4869 38.9693C75.2797 46.0171 66.7515 54.0939 68.4316 57.0041C70.1143 59.9184 81.3705 56.5668 93.5777 49.519C105.785 42.4712 114.32 34.3962 112.637 31.4819C110.957 28.5718 99.694 31.9215 87.4869 38.9693Z",
    fill: "#A3ACBD"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52 19.125C56.9995 19.125 59.875 21.9375 59.875 27H62.125C62.125 21.9375 64.9375 19.125 70 19.125V16.875C64.9375 16.875 62.125 14.0625 62.125 9H59.875C59.875 14.0625 57.0625 16.875 52 16.875V19.125Z",
    fill: "#989FB0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_48240_43587",
    x: 47.7177,
    y: 25.1925,
    width: 86.2054,
    height: 71.0154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.34146,
    dy: 11.9092
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.05268
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_48240_43587"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_48240_43587",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiLogEmpty);
export default __webpack_public_path__ + "static/media/aiLogEmpty.931fa64b4cfee4067e281e37c1c0c949.svg";
export { ForwardRef as ReactComponent };